import React, { useEffect, useState } from "react";
import { Button, Row, Col, Card, Image, Table } from "react-bootstrap";
// import "../Common/Common.css";
import { Formik, Form } from "formik";
import { TextArea } from "../../Common/FormikTemplates/TextArea";
import { TextField } from "../../Common/FormikTemplates/TextField";
import { DropDown } from "../../Common/FormikTemplates/DropDown";
import { Multiselect } from "multiselect-react-dropdown";
import * as Yup from "yup";
import { Link } from "react-router-dom";

import moment from "moment";
var dateFormat = require("dateformat");

const OrganizationDetails = ({ clickHandler, ...props }) => {
  useEffect(() => {}, []);

  let user = JSON.parse(localStorage.getItem("user"));

  const validate = Yup.object({
    orgName: Yup.string().required("Organization Name is required"),
    crNumber: Yup.string().required("Registration Number is required"),
    crExpDate: Yup.string().required("Registration Expiry Date is required"),
    // glCode: Yup.string().required("GL Code is required"),
    spocName: Yup.string().required("SPOC Name  is required"),
    spocDsgntn: Yup.string().required("SPOC Designation is required"),
    spocEmail: Yup.string().required("SPOC Email  is required"),
    spocPhn: Yup.string().required("SPOC Phone is required"),
  });

  return (
    <div className="driverdetsilsdiv">
      <Formik
        enableReinitialize={true}
        initialValues={{
          callingCode: (props.item && props.item.callingCode) || "",
          orgName: (props.item && props.item.orgName) || "",
          crNumber: (props.item && props.item.crNumber) || "",
          crExpDate: (props.item && props.item.crExpDate) || "",
          // glCode: (props.item && props.item.glCode) || "",
          spocName: (props.item && props.item.spocName) || "",
          spocDsgntn: (props.item && props.item.spocDsgntn) || "",
          spocEmail: (props.item && props.item.spocEmail) || "",
          spocPhn: (props.item && props.item.spocPhn) || "",
          hqAddr: (props.item && props.item.hqAddr) || "",
          hqFax: (props.item && props.item.hqFax) || "",
          hqEmail: (props.item && props.item.hqEmail) || "",
          hqPhn: (props.item && props.item.hqPhn) || "",
        }}
        validationSchema={validate}
        // onSubmit={(value) => {

        //   clickHandler(2, value);
        // }}
        onSubmit={(value, { resetForm }) => {
          props.submitForm(value);
        }}
      >
        {(formik) => (
          <div>
            <div>
              <div className="userModalDiv">
                <Form>
                  <Row>
                    <Col lg={12} md={12} sm={12} xs={12}>
                      <div>
                        <p className="shipperhd">Organization Details</p>
                      </div>
                      <Row>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="Organization Name"
                              name="orgName"
                              type="text"
                              isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="Registration Number"
                              name="crNumber"
                              type="text"
                              isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="Registration Expiry Date"
                              name="crExpDate"
                              type="date"
                              min={moment(new Date()).format("YYYY-MM-DD")}
                              isRequired={true}
                            />
                          </div>
                        </Col>
                        {/* <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="GL Code"
                              name="glCode"
                              type="text"
                              isRequired={true}
                            />
                          </div>
                        </Col> */}
                      </Row>

                      <div>
                        <p className="shipperhd">SPOC Details</p>
                      </div>
                      <Row>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="SPOC Name"
                              name="spocName"
                              type="text"
                              isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="SPOC Designation"
                              name="spocDsgntn"
                              type="text"
                              isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="SPOC Email"
                              name="spocEmail"
                              type="text"
                              isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div className="shiperproftextbox">
                            <TextField
                              label="SPOC Phone"
                              name="callingCode"
                              type="text"
                              readOnly={true}
                              isRequired={true}
                            />
                          </div>

                          <div className="shiperproftextbox1">
                            <TextField name="spocPhn" type="text" />
                          </div>
                        </Col>
                      </Row>

                      <div>
                        <p className="shipperhd">Headquaters Details</p>
                      </div>
                      <Row>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="HQ Address"
                              name="hqAddr"
                              type="text"
                              // isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="HQ Fax"
                              name="hqFax"
                              type="text"
                              // isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div>
                            <TextField
                              label="HQ Email"
                              name="hqEmail"
                              type="text"
                              // isRequired={true}
                            />
                          </div>
                        </Col>
                        <Col lg={3} md={3} sm={12} xs={12}>
                          <div className="shiperproftextbox">
                            <TextField
                              label="HQ Phone"
                              name="callingCode"
                              type="text"
                              readOnly={true}
                              // isRequired={true}
                            />
                          </div>

                          <div className="shiperproftextbox1">
                            <TextField name="hqPhn" type="text" />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                  <hr />
                  <Button className="commonaddbutton" type="submit">
                    <span className="commonaddname">SUBMIT</span>
                  </Button>
                  <Button
                    className="commonaddbutton"
                    style={{ marginRight: "10px" }}
                    onClick={() => clickHandler(0)}
                  >
                    <span className="commonaddname">BACK</span>
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        )}
      </Formik>
    </div>
  );
};

export default OrganizationDetails;
